
import TextalignJustifycenter from "../../../assets/duotone/TextalignJustifycenter.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TextalignJustifycenterIcon({ className, dataTestid = "TextalignJustifycenterIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TextalignJustifycenter data-testid={dataTestid} className={classes} {...rest} />
  );
}
